// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC-upftexPbR2Hdv1jA07ue3ktFROQ8TKU",
  authDomain: "negociosnet-32822.firebaseapp.com",
  projectId: "negociosnet-32822",
  storageBucket: "negociosnet-32822.firebasestorage.app",
  messagingSenderId: "668030665553",
  appId: "1:668030665553:web:e743c44fb3820a15228970",
  measurementId: "G-8R7HP84K8H"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
